import script from "./ReportPost.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPost.vue?vue&type=script&setup=true&lang=js"

import "./ReportPost.vue?vue&type=style&index=0&id=9b3ed1f4&lang=scss"

const __exports__ = script;

export default __exports__